export default __webpack_public_path__ + "static/novel-banner-9d98014cd98306f6f406e4c4ce00d266.png";